import React from "react";
import { useState, useEffect } from "react";
import "../CSS/header.css";
import { Header } from "./Header";
import ourWorkImage from "../Project Images/ourWorkImage.jpg";

export const OurWork = () => {
  const [showComponent, setShowComponent] = useState(false);
  useEffect(() => {
    setShowComponent(true);
  }, []);

  return (
    <>
      <Header />

      <div
        className={showComponent ? "about-container show" : "about-container"}
      >
        <div>
          <h2 class="ourWork-title">
            Need a Creative Product? We Can Help You!
          </h2>
        </div>

        <div className="work-container">
          <div className="work-image">
            <img
              src={ourWorkImage}
              height="500px"
              width="500px"
              alt="Franmeet Pic"
            />
          </div>
          <div className="work-text">
            <p>
              Our organization specializes in designing and developing custom
              websites tailored to meet the unique needs and goals of our
              clients. We leverage the latest technologies and design trends to
              create visually stunning and user-friendly websites that
              effectively communicate your brand message and drive engagement.
              <br />
              In addition to creating new websites, we also provide
              comprehensive website maintenance services to ensure that your
              online presence remains up-to-date, secure, and fully functional.
              <br />
              Our digital marketing services are designed to help businesses
              increase their online visibility, attract more traffic, and
              generate leads and sales. We offer a range of digital marketing
              solutions including E-Commerce Marketing like [Amazon ads,
              Flipkart ads], Search Engine Optimization (SEO), Pay-Per-Click
              (PPC) advertising, social media marketing, email marketing,
              content marketing, and more. Our goal is to help you reach your
              target audience effectively and achieve measurable results.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
